export const oldApiEnvironmentStaging = {
  production: true,
  api: 'https://gutwintest.westeurope.cloudapp.azure.com/gutwin',
  applicationKey: '',
  applicationVersion: ''
};
